import script from "./expertSuggest.vue?vue&type=script&setup=true&lang=js"
export * from "./expertSuggest.vue?vue&type=script&setup=true&lang=js"

import "./expertSuggest.vue?vue&type=style&index=0&id=889e15fc&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-889e15fc"]])

export default __exports__